import { Alert, AlertDescription, AlertTitle } from '@lms/ui/alert';
import { InfoIcon } from 'lucide-react';
import { useTranslations } from 'use-intl';

// Ports app/[brand]/admin/courses/_components/empty-list.tsx.
export function EmptyList() {
  const t = useTranslations('addcourse');
  return (
    <Alert className="mx-auto max-w-[30rem]">
      <InfoIcon />
      <AlertTitle>{t('no_courses')}</AlertTitle>
      <AlertDescription>{t('contact_sales_rep')}</AlertDescription>
    </Alert>
  );
}
